<button style="margin-left: -1%;margin-top: 2%;margin-bottom: 2%;margin-bottom: 2%;" mat-button [routerLink]="['/adv-dashboard']"><img src="../../../assets/icons/retour.svg" style="margin-right:12%;">Retour</button>


<ul class="d-flex custom-tab" *ngIf="user.id === '6135c7036457510004c2eef1' || user.role === 'Admin'">
  <li *ngFor="let adv of advs"  [ngClass]="selectedId === adv._id ? 'active-li' : '' " [value]=adv.username (click)="showAdv(adv._id)">{{ adv.username }}</li>
</ul>

<app-suivi-dossiers-detail [userId]="selectedId"></app-suivi-dossiers-detail>
